import React, { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { SubmitHandler } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useCreateCompanyDepartment } from '@area-restrita/api-client/endpoints/departments/departments.gen';
import { UpdateDepartmentDto } from '@area-restrita/api-client/model/updateDepartmentDto';

import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

import DepartmentForm from '../../components/DepartmentForm';

const CreateCompanyDepartments: React.FC = () => {
  const navigate = useNavigate();

  const createCompanyDepartmentMutation = useCreateCompanyDepartment();

  const handleSubmit = useCallback<SubmitHandler<UpdateDepartmentDto>>(
    (data) =>
      createCompanyDepartmentMutation.mutateAsync(
        { data },
        {
          onSuccess: ({ id }) => {
            toast.success('Departamento criado com sucesso');
            navigate({
              to: '/settings/company-departments/$departmentId',
              params: { departmentId: id },
            });
          },
          onError: () => {
            toast.error('Erro ao criar departamento');
          },
        },
      ),
    [createCompanyDepartmentMutation, navigate],
  );
  return (
    <Card>
      <CardHeader>
        <CardTitle>Criar Novo Departamento</CardTitle>
        <CardDescription>
          Aqui você pode criar um novo departamento para as empresas.
        </CardDescription>
      </CardHeader>
      <DepartmentForm onSubmit={handleSubmit} />
    </Card>
  );
};

export default CreateCompanyDepartments;
